import { signal } from '@preact/signals';
import { ModelSelector } from '../ModelSelector';
import type { ComponentShowcase } from '../registry';

const demoModels = signal([
  { id: 'gpt-4o', name: 'GPT-4o', provider: 'OpenAI' },
  { id: 'claude-sonnet-4-20250514', name: 'Claude Sonnet 4', provider: 'Anthropic' },
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash', provider: 'Google' },
]);
const demoSelected = signal('claude-sonnet-4-20250514');
const demoOpen = signal(false);

export const showcase: ComponentShowcase = {
  name: 'ModelSelector',
  category: '💬 Chat',
  description: 'Dropdown de seleção de modelo LLM com ícones por provider e separadores automáticos.',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ position: 'relative', minHeight: 60 }}>
      <ModelSelector models={demoModels} selectedModel={demoSelected} dropdownOpen={demoOpen} />
    </div>
  ),
};
